import { useState } from 'react';

/** Their picture from Google or Discord, or their initial when there's none (or it won't load). */
export function Avatar({ name, picture }: { name: string; picture?: string | undefined }) {
  const [broken, setBroken] = useState(false);
  if (picture && !broken) {
    return <img className="avatar" src={picture} alt="" width={32} height={32} referrerPolicy="no-referrer" onError={() => setBroken(true)} />;
  }
  return <span className="avatar avatar-initial" aria-hidden="true">{name.charAt(0).toUpperCase()}</span>;
}
